import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";
import type { IHaulierListRow } from "../../customTypings/haulier/Haulier";

export type HaulierAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatHaulierToastLabel(name: string | undefined): string {
    const t = typeof name === "string" ? name.trim() : "";
    return t.length > 0 ? t : EntityLabels.haulier;
}

export function getHaulierAdminActionSuccessMessage(
    kind: HaulierAdminConfirmKind,
    name: string | undefined
): string {
    const label = formatHaulierToastLabel(name);
    const successByKind: Record<HaulierAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

export const buildHaulierAdminPagedListActions = buildRecordLifecyclePagedListActions<IHaulierListRow>;

export function canMutateHauliers(roleNames: string[]): boolean {
    const allowed = new Set([
        "System Administrator",
        "Administrator",
        "Office Staff",
        "Yard Staff",
    ]);
    return roleNames.some((r) => allowed.has(r));
}
